var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "detail-main",
    },
    [
      _vm.formInfo.processName
        ? _c("div", { staticClass: "el-row" }, [
            _c(
              "div",
              { staticClass: "el-col el-col-14 process-form-content" },
              [
                _c("div", { staticClass: "process-title" }, [
                  _vm._v("审批详情"),
                ]),
                _vm.formInfo.remark
                  ? _c(
                      "div",
                      { staticClass: "process-remark" },
                      [
                        _c("el-icon", {
                          staticClass: "el-icon-warning-outline",
                        }),
                        _vm._v(_vm._s(_vm.formInfo.remark) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("user-info", { attrs: { user: _vm.userInfo } }),
                _c("div", { staticClass: "form-info" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v("审批单名称："),
                    ]),
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.formInfo.processName)),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("审批编号：")]),
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.formInfo.serialNumber)),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("所在部门：")]),
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.formInfo.initiatorDepartmentHierarchy)),
                    ]),
                  ]),
                ]),
                _c("form-render", {
                  ref: "form",
                  staticClass: "process-form",
                  attrs: {
                    forms: _vm.displayForms,
                    userInfo: _vm.userInfo,
                    readerMode: true,
                  },
                  model: {
                    value: _vm.formData,
                    callback: function ($$v) {
                      _vm.formData = $$v
                    },
                    expression: "formData",
                  },
                }),
                _vm.noticePreview
                  ? _c("notice-approval-preview", {
                      attrs: { preview: _vm.noticePreview },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-col el-col-10 process-timeline" },
              [
                _c("div", { staticClass: "title-timeline" }, [
                  _vm._v("审批流程"),
                ]),
                _c("process-timeline", { attrs: { timeline: _vm.timeline } }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }